import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'config/i18n';
import { get, head } from 'lodash';
import * as moment from 'moment';

// http://kazupon.github.io/vue-i18n/en/
Vue.use(VueI18n);

function getLocale() {
  const locale = localStorage.getItem('locale');

  if (locale) {
    return locale;
  }

  const language = get(window, 'navigator.language');

  return head(language.split('-'));
}

export function loadMomentLocale(locale) {
  moment.locale(locale);
}

const locale = getLocale();
loadMomentLocale(locale);

export default new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages,
});
